module.exports = flarum.core.compat['helpers/icon'];